import React from 'react'
import '../../Style.css';
import '../../Media-styles.css';
import Header from '../../Header';
import Footer from '../../Footer';
import '../Styles/PoolGrid.css';
import Drawing3D from '../../img/3d/HaymanLounger35.png';
import Slider from './Slider';
import PoolFeatures from '../../Pool-Series/Hayman_Launger35-39/Pool-Features';
import PoolDescription from '../../Pool-Series/Hayman_Launger35-39/Pool-Description';
import RangeFlyer from '../../Pool-Series/Hayman_Launger35-39/Range-Flyer';
import { Helmet } from 'react-helmet';

function HaymanL10() {
    return (
        <>
               <Helmet>
                <title>The Hayman Lounger promises effortless outdoor entertainment for the whole family</title>
                <meta name="title" content="Aqua Technics Canada - Hayman Lounger promises effortless outdoor entertainment for the whole family" />
                <meta name="description" content="Hayman Lounger  - Lounger Series - Aqua Technics Canada - Fibreglass Swimming Pools" />
                <meta name="keywords" content="Hayman Lounger - Lounger Series - Aqua Technics Canada - Fibreglass Swimming Pools - Pool Price" />
                <meta property="og:title" content="About og title" />
                <meta property="og:description" content="og-description" />
            </Helmet>
            <Header />

            <div className='inner_container'>


                <div className='inner-body-container'>
                    <div className='inner_body'>
                        <section className="section-container">

                            <div className="section-body">
                                <div className="section-left">
                                    <h2 className="pool-series">
                                    Lounger Series
                                    </h2>
                                    <Slider />


                                </div>

                                <div className="section-right">
                                    <img src={Drawing3D} alt="Hayman Lounger39" />
                                    <RangeFlyer />
                                    <h2 className="pool-feature">
                                    Lounger Series Features
                                    </h2>

                                    <PoolFeatures />


                                </div>
                            </div>
                            <PoolDescription />
                        </section>

                    </div>

                </div>
            </div>

            <Footer />
        </>
    )
}

export default HaymanL10
